import { useSelector } from 'react-redux';
import { getLotteryStatus } from '../../ducks/lottery';
import { IStore } from 'store/interface';
import { LotteryStatuses } from '../../interfaces';

export const useLotteryStatus = () => ({
  status: useSelector<IStore, LotteryStatuses>(getLotteryStatus),
});
